import type { ReactNode } from "react";
import { LDProvider } from "launchdarkly-react-client-sdk";
import { useAuthenticated } from "../../authn";
import { detectSubdomain } from "../../brand-config";
import { buildLdUserContext } from "../utils/buildLdUserContext";

interface FeatureFlagProviderProps {
  clientSideId: string;
  children: ReactNode;
}

export function FeatureFlagProvider({
  clientSideId,
  children,
}: FeatureFlagProviderProps) {
  const auth = useAuthenticated();

  const ldContext = buildLdUserContext({
    userId: auth.userId,
    name: auth.user.name,
    email: auth.user.email,
    subdomain: detectSubdomain(),
  });

  return (
    <LDProvider
      clientSideID={clientSideId}
      context={ldContext}
      reactOptions={{ useCamelCaseFlagKeys: false }}
    >
      {children}
    </LDProvider>
  );
}
